import React, { useState } from "react";
import ReactPlayer from "react-player";
import { Card, Checkbox } from "@my-scoot/component-library-legacy";
import IconButton from "@material-ui/core/IconButton";

import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import style from "./PrivateVideo.module.css";
import { useFetchPreviewableMediaItemUrl } from "utils/recordedContentUtils/recordedContentUtils";

function PrivateVideo({ title, isSelected, onToggle, ...rest }) {
  const [showVideo, setShowVideo] = useState(false);
  const { height } = rest;
  return (
    <Card className={style.card}>
      <div onClick={onToggle} className={style.checkboxWrap}>
        <Checkbox checked={isSelected} tabIndex={-1} size="large" />
      </div>

      {showVideo ? (
        <Video {...rest} />
      ) : (
        <div style={{ height }} className={style.thumbnail}>
          <IconButton onClick={() => setShowVideo(true)}>
            <PlayCircleFilledWhiteIcon className={style.thumbnailIcon} />
          </IconButton>
        </div>
      )}
      <h3 className={style.title}>{title}</h3>
    </Card>
  );
}

export function Video({ url, width, height }) {
  const { previewableUrl } = useFetchPreviewableMediaItemUrl(url);

  if (!previewableUrl) return null;

  return (
    <ReactPlayer
      source="media"
      url={previewableUrl}
      width={width}
      height={height}
      controls
    />
  );
}

export default PrivateVideo;
